import styles from './ConfirmacaoPedido.module.css'

function ConfirmacaoPedido(){
    return(
        <div>

        </div>
    )
}

export default ConfirmacaoPedido